import { useMutation } from '@tanstack/react-query';

import { clientApi } from '@/config/axios';

export interface ChangePasswordPayload {
  current_password: string;
  new_password: string;
}

/**
 * Change the signed-in user's own password.
 *
 * The current password is sent as well as the bearer token: tokens last 24h,
 * live in localStorage and cannot be revoked, so the API re-authenticates rather
 * than treating a token as sufficient to take an account over.
 */
export function useChangePassword() {
  return useMutation({
    mutationFn: async (payload: ChangePasswordPayload) => {
      await clientApi.post('/api/v1/auth/change-password', payload);
    },
  });
}
